import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './scss/volt.scss';
import 'react-datetime/css/react-datetime.css';

import HomePage from './pages/HomePage';
import ScrollToTop from './components/ScrollToTop';
import RouteSeo from './components/RouteSeo';
import { AuthProvider } from './context/AuthContext';
import { AdminAuthProvider } from './context/AdminAuthContext';

ReactDOM.render(
  <BrowserRouter>
    <AuthProvider>
      <AdminAuthProvider>
        <RouteSeo />
        <ScrollToTop />
        <HomePage />
      </AdminAuthProvider>
    </AuthProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
